import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import userSlice from "./slices/User/userSlice";
import dmsDataGridProPageSlice from "./slices/DmsDataGridPro/dmsDataGridProPageSlice";
const reducer = combineReducers({
  user: userSlice,
  dmsDataGridProPage: dmsDataGridProPageSlice,
});

export const store = configureStore({
  reducer,
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(searchFilterApi.middleware),
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
setupListeners(store.dispatch);
